import { Routes } from '@angular/router';import { authGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () =>
      import('./features/auth/login.component').then((m) => m.LoginComponent),
    title: 'Login — SellerSage Admin',
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./shared/components/layout/shell.component').then((m) => m.ShellComponent),
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/dashboard.component').then((m) => m.DashboardComponent),
        title: 'Dashboard',
      },
      {
        path: 'tenants',
        loadChildren: () =>
          import('./features/tenants/tenants.routes').then((m) => m.TENANTS_ROUTES),
        title: 'Tenant Management',
      },
      {
        path: 'campaigns',
        loadChildren: () =>
          import('./features/campaigns/campaigns.routes').then((m) => m.CAMPAIGNS_ROUTES),
        title: 'Email Campaigns',
      },
      {
        path: 'system-health',
        loadComponent: () =>
          import('./features/system-health/system-health.component').then(
            (m) => m.SystemHealthComponent,
          ),
        title: 'System Health',
      },
      {
        path: 'scheduler',
        loadComponent: () =>
          import('./features/scheduler/scheduler.component').then((m) => m.SchedulerComponent),
        title: 'Agent Scheduler',
      },
      {
        path: 'model-router',
        loadComponent: () =>
          import('./features/model-router/model-router.component').then(
            (m) => m.ModelRouterComponent,
          ),
        title: 'AI Model Router Config',
      },
      {
        path: 'model-catalog',
        loadChildren: () =>
          import('./features/model-catalog/model-catalog.routes').then(
            (m) => m.MODEL_CATALOG_ROUTES,
          ),
        title: 'Model Catalog',
      },
      {
        path: 'seasonal-events',
        loadChildren: () =>
          import('./features/seasonal-events/seasonal-events.routes').then(
            (m) => m.SEASONAL_EVENTS_ROUTES,
          ),
        title: 'Seasonal Events',
      },
      {
        path: 'pmk-costs',
        loadComponent: () =>
          import('./features/pmk-costs/pmk-costs.component').then((m) => m.PmkCostsComponent),
        title: 'PMK Cost Dashboard',
      },
      {
        path: 'analytics-monitor',
        loadComponent: () =>
          import('./features/analytics-monitor/analytics-monitor.component').then(
            (m) => m.AnalyticsMonitorComponent,
          ),
        title: 'Predictive Analytics Monitor',
      },
      {
        path: 'india-tenants',
        loadComponent: () =>
          import('./features/india-tenants/india-tenants.component').then(
            (m) => m.IndiaTenantsComponent,
          ),
        title: 'India Tenants',
      },
      {
        path: 'billing',
        loadComponent: () =>
          import('./features/billing/billing.component').then((m) => m.BillingComponent),
        title: 'Billing Overview',
      },
      {
        path: 'audit-log',
        loadComponent: () =>
          import('./features/audit-log/audit-log.component').then((m) => m.AuditLogComponent),
        title: 'Audit Log',
      },
      {
        path: 'ai-consumption',
        loadComponent: () =>
          import('./features/ai-consumption/ai-consumption.component').then(
            (m) => m.AiConsumptionComponent,
          ),
        title: 'AI Consumption',
      },
      {
        path: 'discounts',
        loadComponent: () =>
          import('./features/discounts/discounts.component').then((m) => m.DiscountsComponent),
        title: 'Discount Manager',
      },
    ],
  },
  { path: '**', redirectTo: 'dashboard' },
];
;
